// LaunchDarkly feature flag for Insights Agent
export const INSIGHTS_FEATURE_FLAG = 'data-insights-agent';

export const INSIGHTS_LEARN_MORE_URL = 'https://help.fulcrumapp.com/en/articles/11586112';
